/* AUTO-GENERATED from src/styles/tokens-*.css. Do not edit by hand.
 * Output is deterministic — regenerating with the same inputs produces a
 * byte-identical file. The pre-push freshness guard relies on this.
 */

export const tokens = {
  color: {
    "rich-black": "#1A212E",
    "white": "#FFFFFF",
    "gray-1": "#646A7C",
    "gray-2": "#878787",
    "gray-3": "#A9A9A9",
    "gray-3-5": "#CCCCCC",
    "gray-4": "#E7E7E7",
    "gray-5": "#F1F1F1",
    "gray-6": "#F8F8F8",
    "gray-400": "#69717F",
    "darker-blue": "#002136",
    "middle-blue": "#1D2F44",
    "dark-blue": "#334255",
    "deep-navy": "#050E1A",
    "teal": "#197E95",
    "teal-active": "#00566A",
    "teal-accessible": "#18768C",
    "teal-accessible-5": "rgba(24, 118, 140, 0.05)",
    "bright-teal": "#2CDADA",
    "bright-teal-active": "#12ABAB",
    "teal-accent": "#28BABA",
    "bright-blue": "#66FCFC",
    "light-teal": "#F3F8F9",
    "glow-teal": "#5DA8B5",
    "pink": "#CD37A3",
    "dark-teal-grey": "#2B4855",
    "deep-teal": "#177474",
    "grey-45": "#EBEDF1",
    "near-black": "#101C2A",
    "magenta-bright": "#C02195",
    "magenta-dark": "#E449BD",
    "magenta-accessible-dark-bg": "#FF77DD",
    "orange-bright": "#E05729",
    "orange-dark": "#FF6E53",
    "yellow-bright": "#BC7D01",
    "yellow-dark": "#FEC350",
    "yellow-text-bright": "#9E5F00",
    "yellow-200": "#F7FCB9",
    "green-200": "#ADDD8E",
    "green-300": "#31A354",
    "white-10": "rgba(255, 255, 255, 0.10)",
    "white-20": "rgba(255, 255, 255, 0.20)",
    "white-40": "rgba(255, 255, 255, 0.40)",
    "white-60": "rgba(255, 255, 255, 0.60)",
    "white-85": "rgba(255, 255, 255, 0.85)",
    "darker-blue-20": "rgba(0, 33, 54, 0.20)",
    "darker-blue-60": "rgba(0, 33, 54, 0.60)",
    "darker-blue-90": "rgba(0, 33, 54, 0.90)",
    "deep-navy-60": "rgba(5, 14, 26, 0.60)",
    "magenta-bright-20": "rgba(192, 33, 149, 0.20)",
    "gray-1-10": "rgba(100, 106, 124, 0.10)",
    "gray-1-20": "rgba(100, 106, 124, 0.20)",
    "glass-grey-light": "rgba(80, 86, 92, 0.76)",
    "gray-1-30": "rgba(100, 106, 124, 0.30)",
    "teal-10": "rgba(25, 126, 149, 0.10)",
    "teal-accessible-20": "rgba(24, 118, 140, 0.20)",
    "glow-teal-60": "rgba(93, 168, 181, 0.60)",
    "gray-4-90": "rgba(241, 241, 241, 0.90)",
    "magenta-bright-5": "rgba(192, 33, 149, 0.05)",
    "magenta-bright-30": "rgba(192, 33, 149, 0.30)",
    "magenta-dark-5": "rgba(228, 73, 189, 0.05)",
    "magenta-dark-30": "rgba(228, 73, 189, 0.30)",
    "dark-teal-grey-40": "rgba(43, 72, 85, 0.40)",
    "dark-teal-grey-60": "rgba(43, 72, 85, 0.60)",
    "near-black-60": "rgba(16, 28, 42, 0.60)",
    "bright-teal-40": "rgba(44, 218, 218, 0.40)",
    "charcoal-15": "rgba(50, 50, 52, 0.15)",
    "charcoal-25": "rgba(50, 50, 52, 0.25)",
    "state-error": "#993838",
    "state-warning": "#9D6309",
  },
  space: {
    "s2": "2px",
    "s4": "4px",
    "s8": "8px",
    "s12": "12px",
    "s16": "16px",
    "s24": "24px",
    "s32": "32px",
    "s40": "40px",
    "s48": "48px",
    "s64": "64px",
    "s80": "80px",
    "s128": "128px",
  },
  font: {
    "family-avenir": "'avenir-lt-pro', 'Avenir', 'Avenir Next', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    "family-arial": "Arial, sans-serif",
    "weight-light": "300",
    "weight-book": "400",
    "weight-medium": "500",
    "weight-heavy": "800",
    "weight-350": "350",
    "family-avenir-lt-pro": "\"Avenir LT Pro\", \"avenir-lt-pro\", \"Avenir\", \"Avenir Next\", \"Helvetica Neue\", sans-serif",
    "size-64": "64px",
    "line-height-64": "70.4px",
    "size-48": "48px",
    "line-height-48": "52px",
    "size-38": "38px",
    "line-height-38": "42px",
    "size-28": "28px",
    "line-height-28": "34px",
    "size-22": "22px",
    "line-height-22": "normal",
    "line-height-22-tight": "28px",
    "size-19": "19px",
    "line-height-19": "normal",
    "size-16": "16px",
    "line-height-16": "24px",
    "size-14": "14px",
    "line-height-14": "normal",
  },
  gradient: {
    "dark-radial": "radial-gradient(circle, #002136 0%, #002136 28.91%, #071D2D 63.28%, #0B0C0E 83.07%)",
    "bright-radial": "radial-gradient(circle, #E3ECEF 0%, #F1F1F1 100%)",
    "bright-linear-right": "linear-gradient(to right, #197E95 0%, #F8F8F8 100%)",
    "bright-linear-left": "linear-gradient(to left, #197E95 0%, #F8F8F8 100%)",
    "dark-linear-top": "linear-gradient(to top, #002136 0%, #183F58 43.56%, #197E95 100%)",
    "bright-teal": "linear-gradient(to right, #197E95 0%, #F8F8F8 98.45%)",
    "glass-hover": "linear-gradient(353deg, #2B4855 29.96%, #177474 103.03%)",
    "glass-selected": "linear-gradient(176deg, #2CDADA 14.25%, #177474 102.74%)",
    "light-teal-hover": "linear-gradient(353deg, #2CDADA 29.96%, #7DFFFF 103.03%)",
  },
  breakpoint: {
    "sm": 768,
    "md": 992,
    "lg": 1200,
    "xl": 1600,
  },
  misc: {
    "elevation-toggle-tabs-pill": "0 2px 24px 0 rgba(50, 50, 52, 0.15)",
    "elevation-card-soft": "0 2px 24px 0 rgba(50, 50, 52, 0.25)",
    "elevation-glow-bright-teal": "0 12px 64px 0 rgba(44, 218, 218, 0.40)",
    "blur-glass": "6px",
    "letter-spacing-hero-h1": "-2.24px",
    "motion-duration-120": "120ms",
    "motion-duration-200": "200ms",
    "motion-duration-400": "400ms",
    "motion-duration-450": "450ms",
    "motion-duration-650": "650ms",
    "motion-duration-700": "700ms",
    "motion-ease-emphasized": "cubic-bezier(0.2, 0, 0, 1)",
    "motion-ease-accelerate": "cubic-bezier(0.4, 0, 1, 1)",
    "motion-ease-entrance": "cubic-bezier(0.16, 1, 0.3, 1)",
    "motion-stagger-80": "80ms",
  },
} as const;

export type Tokens = typeof tokens;

/* Tier 3 component tokens — chained Tier 3 → Tier 2 → Tier 1, resolved to hex.
 * MUI theme.components.<Component>.variants consumes these directly.
 * Grouped by primitive prefix (e.g., --hd-c-btn-* → componentTokens.btn).
 *
 * ⚠️  NOT DARK-MODE SAFE.
 * These values are a build-time flattening of LIGHT-THEME variables. Any
 * `[data-theme="dark"]` override authored in tokens-semantic.css is ignored
 * here — consumers reading componentTokens (theme/components.ts) will see
 * light-mode hex in both themes. If dark mode becomes a requirement,
 * migration to MUI CssVarsProvider (5.13+) is the supported path. See
 * architecture.txt § "Dark mode".
 */
export const componentTokens = {
  btn: {
    "primaryDarkBg": "#002136",
    "primaryDarkFg": "#FFFFFF",
    "primaryBrightBg": "#FFFFFF",
    "primaryBrightFg": "#002136",
    "secondaryBorder": "#002136",
    "secondaryFg": "#002136",
    "secondaryBrightBorder": "rgba(255, 255, 255, 0.85)",
    "secondaryBrightFg": "#FFFFFF",
    "secondaryBrightFocusRing": "#FFFFFF",
    "secondaryBrightDisabled": "#CCCCCC",
    "iconFg": "#FFFFFF",
    "primaryDarkFocusRing": "#2CDADA",
    "primaryBrightFocusRing": "#FFFFFF",
    "secondaryFocusRing": "#002136",
    "iconFocusRing": "#FFFFFF",
    "disabledBg": "#CCCCCC",
    "disabledFg": "#878787",
    "disabledFgBright": "#CCCCCC",
    "disabledBorder": "#878787",
  },
  avatar: {
    "neutralBg": "#69717F",
    "neutralFg": "#FFFFFF",
    "brightBlueBg": "#66FCFC",
    "brightBlueFg": "#002136",
    "brightTealBg": "#2CDADA",
    "brightTealFg": "#002136",
    "tealBg": "#18768C",
    "tealFg": "#FFFFFF",
    "darkerBlueBg": "#002136",
    "darkerBlueFg": "#FFFFFF",
    "tealActiveBg": "#00566A",
    "tealActiveFg": "#FFFFFF",
  },
  checkbox: {
    "borderDefault": "#646A7C",
    "borderHover": "#002136",
    "borderError": "#C02195",
    "bgDefault": "#FFFFFF",
    "bgDisabled": "#CCCCCC",
    "checkFg": "#002136",
    "focusRing": "#002136",
  },
  infobox: {
    "bg": "rgba(192, 33, 149, 0.05)",
    "border": "rgba(192, 33, 149, 0.20)",
    "fg": "#C02195",
  },
  footer: {
    "darkBg": "#334255",
    "darkFg": "#CCCCCC",
    "lightBg": "#FFFFFF",
    "lightFg": "#002136",
    "lightSeparator": "rgba(100, 106, 124, 0.20)",
  },
  link: {
    "fgEmphasisBright": "#002136",
    "fgSubtleBright": "#334255",
    "fgDark": "#FFFFFF",
    "fgDisabled": "#A9A9A9",
    "bgHoverBright": "rgba(100, 106, 124, 0.10)",
    "bgHoverDark": "rgba(255, 255, 255, 0.10)",
    "focusRingBright": "#002136",
    "focusRingDark": "#FFFFFF",
  },
  icondropdown: {
    "borderDefault": "#CCCCCC",
    "borderInteractive": "#1A212E",
    "fgIcon": "#1A212E",
    "fgLabel": "#002136",
    "focusRingInner": "#CCCCCC",
  },
  menuitem: {
    "fgText": "#002136",
    "fgChevron": "#1A212E",
    "underline": "#002136",
    "focusRing": "#334255",
  },
  linkcard: {
    "bgGrey": "#F3F8F9",
    "bgWhite": "#FFFFFF",
    "borderWhite": "#E7E7E7",
    "fgTitle": "#002136",
    "fgTitleUnactive": "#646A7C",
    "fgBody": "#334255",
    "fgBodyUnactive": "#646A7C",
  },
  spinner: {
    "fg": "#18768C",
  },
  toggle: {
    "trackOffBg": "#646A7C",
    "trackOnBg": "#002136",
    "trackDisabledBg": "#F1F1F1",
    "trackBorderResting": "#646A7C",
    "trackBorderOn": "#002136",
    "trackBorderFocusOff": "#002136",
    "knobBg": "#FFFFFF",
    "knobDisabledBg": "#CCCCCC",
    "iconOffResting": "#646A7C",
    "iconOffActive": "#334255",
    "iconOn": "#002136",
    "iconDisabled": "#878787",
    "focusRingOn": "#002136",
  },
  tab: {
    "text": "#1A212E",
    "underline": "#334255",
    "focusRing": "#002136",
    "selectedBackdrop": "#FFFFFF",
    "mobileBg": "#FFFFFF",
    "mobileDivider": "#E7E7E7",
  },
  tooltip: {
    "iconBgDefault": "#002136",
    "iconBgDisabled": "#CCCCCC",
    "iconGlyphDefault": "#FFFFFF",
    "iconGlyphDisabled": "#878787",
    "iconStrokeHover": "#002136",
    "iconFocusRing": "#002136",
    "bubbleBg": "#002136",
    "bubbleFg": "#FFFFFF",
  },
  input: {
    "bgDefault": "#FFFFFF",
    "bgDisabled": "#F8F8F8",
    "borderDefault": "#646A7C",
    "borderFocus": "#002136",
    "borderError": "#C02195",
    "textPlaceholder": "#646A7C",
    "textValue": "#002136",
    "textLabel": "#002136",
    "textAsterisk": "#002136",
    "textAsteriskError": "#C02195",
    "textErrorMessage": "#C02195",
    "feedbackHelpText": "#993838",
    "feedbackWarningDot": "#9D6309",
  },
  navbar: {
    "bg": "#FFFFFF",
    "divider": "rgba(100, 106, 124, 0.20)",
    "borderBottom": "rgba(100, 106, 124, 0.20)",
    "labelFg": "#002136",
  },
  toggletabs: {
    "chassisBg": "#F1F1F1",
    "selectedBg": "#FFFFFF",
    "selectedShadow": "0 2px 24px 0 rgba(50, 50, 52, 0.15)",
    "itemFg": "#002136",
    "itemHoverBg": "rgba(100, 106, 124, 0.10)",
    "focusRing": "#002136",
  },
  step: {
    "tileDefaultBg": "transparent",
    "tileSelectedBg": "#002136",
    "tileDoneBg": "#F8F8F8",
    "labelDefaultFg": "#646A7C",
    "labelSelectedFg": "#002136",
    "iconSelectedFg": "#FFFFFF",
    "iconDoneFg": "#002136",
  },
  statusbadge: {
    "fgBright": "#002136",
    "fgDark": "#FFFFFF",
  },
  timingpill: {
    "dotLight": "#FF77DD",
    "dotDark": "#C02195",
    "fgLight": "#002136",
    "fgDark": "#FFFFFF",
  },
  card: {
    "bgLightPrimary": "#FFFFFF",
    "bgLightSecondary": "#F1F1F1",
    "bgDarkPrimary": "#002136",
    "bgDarkSecondary": "#334255",
    "shadow": "0 2px 24px 0 rgba(50, 50, 52, 0.25)",
    "fgLight": "#002136",
    "fgDark": "#FFFFFF",
    "dividerLight": "rgba(0, 33, 54, 0.60)",
    "dividerDark": "rgba(255, 255, 255, 0.40)",
  },
  boxcard: {
    "defaultBg": "#002136",
    "finishedBg": "#F1F1F1",
    "defaultFg": "#FFFFFF",
    "finishedFg": "#002136",
    "finishedCheckBg": "#002136",
    "finishedCheckFg": "#FFFFFF",
  },
  instructionsbox: {
    "bg": "#FFFFFF",
    "fg": "#002136",
    "divider": "rgba(100, 106, 124, 0.20)",
    "shadow": "0 2px 24px 0 rgba(50, 50, 52, 0.15)",
  },
  contact: {
    "bannerSurfaceBase": "#F3F8F9",
    "bannerSurfaceGradientTint": "rgba(25, 126, 149, 0.10)",
    "bannerFg": "#002136",
    "bannerFocusRing": "#002136",
  },
  ratingscaleitems: {
    "bgNotRated": "#CCCCCC",
    "bgNeedsDevelopment": "#F7FCB9",
    "bgMeetsExpectations": "#ADDD8E",
    "bgExceedsExpectations": "#31A354",
    "border": "#646A7C",
  },
  ratingscale: {
    "labelFg": "#1A212E",
  },
  assessmentcard: {
    "bgDefault": "rgba(43, 72, 85, 0.60)",
    "bgHover": "linear-gradient(353deg, #2B4855 29.96%, #177474 103.03%)",
    "bgSelected": "linear-gradient(176deg, #2CDADA 14.25%, #177474 102.74%)",
    "bgSelectedBase": "rgba(16, 28, 42, 0.60)",
    "borderHover": "#66FCFC",
    "shadowHover": "0 12px 64px 0 rgba(44, 218, 218, 0.40)",
    "fgNum": "#FFFFFF",
    "fgNumSelected": "#002136",
    "fgTitle": "#FFFFFF",
    "fgTitleSelected": "#002136",
    "fgDesc": "#EBEDF1",
    "fgDescSelected": "#002136",
    "focusRing": "#66FCFC",
    "focusRingOnSelected": "#1A212E",
    "glassBlur": "6px",
    "bgDefaultLight": "rgba(24, 118, 140, 0.05)",
    "borderDefaultLight": "#002136",
    "bgHoverLight": "rgba(24, 118, 140, 0.20)",
    "borderHoverLight": "#002136",
    "bgSelectedLight": "#002136",
    "fgDefaultLight": "#002136",
    "fgSelectedLight": "#FFFFFF",
    "fgDescLight": "#334255",
    "fgDescSelectedLight": "#F8F8F8",
    "focusRingLight": "#00566A",
    "focusRingOnSelectedLight": "#66FCFC",
  },
  assessmentscale: {
    "panelBg": "rgba(43, 72, 85, 0.40)",
    "panelBgLight": "rgba(24, 118, 140, 0.05)",
    "panelBorderLight": "#002136",
    "dotBorderLight": "rgba(0, 33, 54, 0.60)",
    "dotFgLight": "#002136",
    "dotBgHoverLight": "rgba(24, 118, 140, 0.20)",
    "dotBorderHoverLight": "#18768C",
    "dotBgSelectedLight": "#002136",
    "dotFgSelectedLight": "#FFFFFF",
  },
  assessmentnav: {
    "dividerBg": "rgba(255, 255, 255, 0.20)",
    "titleFg": "#F8F8F8",
    "glassBg": "rgba(5, 14, 26, 0.60)",
    "glassBorder": "rgba(255, 255, 255, 0.10)",
    "dividerBgLight": "rgba(100, 106, 124, 0.20)",
    "titleFgLight": "#334255",
    "glassBgLight": "rgba(255, 255, 255, 0.60)",
    "glassBorderLight": "rgba(100, 106, 124, 0.20)",
  },
  assessmentprogress: {
    "trackBg": "rgba(255, 255, 255, 0.20)",
    "fillBg": "#FFFFFF",
    "labelFg": "#CCCCCC",
    "trackBgLight": "rgba(0, 33, 54, 0.20)",
    "fillBgLight": "#002136",
    "labelFgLight": "#334255",
  },
  assessmentsectionlist: {
    "numberFg": "#FFFFFF",
    "labelFg": "#66FCFC",
    "divider": "rgba(255, 255, 255, 0.20)",
    "numberFgLight": "#002136",
    "labelFgLight": "#002136",
    "dividerLight": "rgba(100, 106, 124, 0.20)",
  },
  assessmenteyebrow: {
    "textFg": "#CCCCCC",
    "dividerBg": "#5DA8B5",
    "dividerGlow": "rgba(93, 168, 181, 0.60)",
    "textFgLight": "#334255",
    "dividerBgLight": "#18768C",
    "dividerGlowLight": "rgba(93, 168, 181, 0.60)",
  },
  assessmentfreeresponse: {
    "border": "#646A7C",
    "textFg": "#FFFFFF",
    "placeholderFg": "#646A7C",
    "counterFg": "#FFFFFF",
    "focusRing": "#FFFFFF",
    "borderLight": "#334255",
    "textFgLight": "#002136",
    "placeholderFgLight": "#646A7C",
    "counterFgLight": "#334255",
    "focusRingLight": "#002136",
    "bgLight": "rgba(255, 255, 255, 0.20)",
  },
  errormessage: {
    "fg": "#FF77DD",
    "fgLight": "#C02195",
  },
  assessmentbackground: {
    "base": "#050E1A",
    "glow": "#5DA8B5",
    "arc": "#00566A",
    "dot": "#00566A",
    "circleStroke": "#FFFFFF",
    "baseLight": "#F3F8F9",
    "glowLight": "#5DA8B5",
    "arcLight": "#28BABA",
    "dotLight": "#28BABA",
    "circleStrokeLight": "rgba(100, 106, 124, 0.20)",
  },
  assessmentquestionbackground: {
    "base": "#050E1A",
    "glow": "#5DA8B5",
    "baseLight": "#F3F8F9",
    "glowLight": "#5DA8B5",
  },
  radio: {
    "borderDefault": "#646A7C",
    "borderHover": "#18768C",
    "borderError": "#C02195",
    "bgDefault": "#FFFFFF",
    "bgDisabled": "#CCCCCC",
    "dotFg": "#002136",
    "dotFgDisabled": "#646A7C",
    "focusRing": "#18768C",
  },
  radiobox: {
    "chassisBg": "#F8F8F8",
    "chassisBorderHover": "#18768C",
    "chassisBorderError": "#C02195",
    "labelFg": "#002136",
    "labelFgDisabled": "#646A7C",
    "focusRing": "#18768C",
  },
  assessmentquestionoption: {
    "bgDefault": "rgba(43, 72, 85, 0.60)",
    "bgHover": "linear-gradient(353deg, #2B4855 29.96%, #177474 103.03%)",
    "bgSelected": "linear-gradient(176deg, #2CDADA 14.25%, #177474 102.74%)",
    "bgSelectedBase": "rgba(16, 28, 42, 0.60)",
    "borderHover": "#66FCFC",
    "shadowHover": "0 12px 64px 0 rgba(44, 218, 218, 0.40)",
    "fgRest": "#F8F8F8",
    "fgRestSm": "#FFFFFF",
    "fgRestTablet": "#EBEDF1",
    "fgSelectedSm": "#1A212E",
    "fgSelected": "#002136",
    "focusRing": "#66FCFC",
    "focusRingOnSelected": "#1A212E",
    "fgDisabled": "#A9A9A9",
    "labelFg": "#66FCFC",
    "defaultRingLight": "rgba(0, 33, 54, 0.60)",
    "bgDefaultLight": "rgba(80, 86, 92, 0.76)",
    "fgRestLight": "#002136",
    "fgRestSmLight": "#002136",
    "fgSelectedSmLight": "#FFFFFF",
    "borderHoverLight": "#18768C",
    "labelFgLight": "#00566A",
  },
  assessmentquestionstacked: {
    "textFg": "#EBEDF1",
    "bg": "rgba(43, 72, 85, 0.40)",
    "divider": "rgba(255, 255, 255, 0.10)",
    "borderError": "#FF77DD",
    "textFgLight": "#002136",
    "bgLight": "rgba(24, 118, 140, 0.05)",
    "dividerLight": "rgba(100, 106, 124, 0.20)",
    "borderErrorLight": "#C02195",
  },
  assessmentmultiquestion: {
    "rule": "#66FCFC",
    "instructionsFg": "#CCCCCC",
    "instructionsAccent": "#66FCFC",
    "legendCircleBg": "rgba(43, 72, 85, 0.60)",
    "legendNumberFg": "#F8F8F8",
    "legendCaptionFg": "#CCCCCC",
    "legendConnector": "rgba(255, 255, 255, 0.20)",
    "legendDivider": "rgba(255, 255, 255, 0.10)",
  },
  ratingdots: {
    "dotBgLight": "#002136",
    "dotBgDark": "rgba(43, 72, 85, 0.60)",
    "dotFgLight": "#FFFFFF",
    "dotFgDark": "#EBEDF1",
    "captionFgLight": "#002136",
    "captionFgDark": "#FFFFFF",
    "panelBgDark": "rgba(43, 72, 85, 0.40)",
    "dividerDark": "rgba(255, 255, 255, 0.10)",
    "dividerLight": "rgba(100, 106, 124, 0.20)",
  },
  inforow: {
    "numberFgLight": "#002136",
    "numberFgDark": "#FFFFFF",
    "captionFgLight": "#334255",
    "captionFgDark": "#CCCCCC",
    "dividerLight": "rgba(100, 106, 124, 0.20)",
    "dividerDark": "rgba(255, 255, 255, 0.20)",
  },
} as const;

export type ComponentTokens = typeof componentTokens;
